import { useContext, useEffect, useState } from 'react';
import { useDrag } from '@use-gesture/react';

import { ViContext } from '../../context/ViContext';
import { MapContext } from '../../context/MapContext';
import { useRef } from 'react';

function Popup(props) {
	const {
		sggMap,
		emdMap,
		weightedMap,
		sggPopupValue,
		emdPopupValue,
		weightedPopupValue,
		setSggPopupValue,
		setEmdPopupValue,
		setWeightedPopupValue,
	} = useContext(MapContext);
	const { mapMode, sidoCode, sggCode, emdCode, pop, consume, prod } =
		useContext(ViContext);

	const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
	const [popupBind, setPopupBind] = useState({ x: 0, y: 0 });
	const [data, setData] = useState(null);

	const popupRef = useRef(null);

	const matchTarget = {
		sgg: sggPopupValue,
		emd: emdPopupValue,
		weighted: weightedPopupValue,
	};

	const matchTargetSetter = {
		sgg: setSggPopupValue,
		emd: setEmdPopupValue,
		weighted: setWeightedPopupValue,
	};

	const target = matchTarget[props.type];
	const targetSetter = matchTargetSetter[props.type];

	const handleLayerSelectionPopoverOpen = (event) => {
		setPopupPosition({
			y: event.originalEvent.clientY,
			x: event.originalEvent.clientX,
		});
	};

	const bind = useDrag((ele) => {
		setPopupBind({
			x: ele.offset[0],
			y: ele.offset[1],
		});

		let x = ele.offset[0] - popupBind.x + popupPosition.x;
		let y = ele.offset[1] - popupBind.y + popupPosition.y;

		setPopupPosition({
			x: x,
			y: y,
		});
	});

	const onClickPopupClose = () => {
		setPopupPosition({ x: 0, y: 0 });
		setPopupBind({ x: 0, y: 0 });
		targetSetter(null);
		setData(null);
	};

	useEffect(() => {
		return () => {
			setPopupPosition({ x: 0, y: 0 });
			setPopupBind({ x: 0, y: 0 });
			targetSetter(null);
			setData(null);
		};
	}, []);

	useEffect(() => {
		const matchMap = {
			sgg: sggMap,
			emd: emdMap,
			weighted: weightedMap,
		};
		if (matchMap[props.type]) {
			matchMap[props.type].on('click', (e) =>
				handleLayerSelectionPopoverOpen(e)
			);
		}
	}, [sggMap, emdMap, weightedMap]);

	useEffect(() => {
		setPopupPosition({ x: 0, y: 0 });
		setPopupBind({ x: 0, y: 0 });
		targetSetter(null);
		setData(null);
	}, [mapMode, sidoCode, sggCode, emdCode]);

	useEffect(() => {
		if (target) {
			const { amd_cd } = target;
			let regionName;
			let regionVal;
			let weightedVal;
			let popVal;
			let consumeVal;
			let prodVal;
			if (amd_cd) {
				regionName = target.amd_nm;
				regionVal = target.vi.toFixed(2);
				popVal = target.m12.toFixed(2);
				consumeVal = target.m34.toFixed(2);
				prodVal = target.m56.toFixed(2);
			} else {
				regionName = `${target.sido_nm_k} ${target.sgg_nm_k}`;
				regionVal = target.lv1_all.toFixed(2);
				popVal = target.l1_1.toFixed(2);
				consumeVal = target.l1_2.toFixed(2);
				prodVal = target.l1_3.toFixed(2);
			}

			if (pop === 1 && consume === 1 && prod === 1) {
				setData({
					weighted: false,
					regionName,
					regionVal,
					popVal,
					consumeVal,
					prodVal,
				});
			} else {
				weightedVal = (
					(popVal * pop + consumeVal * consume + prodVal * prod) /
					(pop + consume + prod)
				).toFixed(2);
				setData({
					weighted: true,
					regionName,
					weightedVal,
					regionVal,
					popVal,
					consumeVal,
					prodVal,
				});
			}
		}
	}, [target]);

	if (!data) return null;

	return (
		<div
			{...bind()}
			id="popup"
			className="popup"
			ref={popupRef}
			style={{
				top: `${popupPosition.y - 50}px`,
				left: `${
					props.type === 'emd' ? popupPosition.x - 1125 : popupPosition.x
				}px`,
			}}
			// style={{ top: `${popupPosition.y + popupBind.y}px`, left: `${popupPosition.x + popupBind.x}px` }}
		>
			<div>
				<header id="popupHeader">
					<p>{data.regionName}</p>
					<button
						className="popupCloseIconButton"
						type="button"
						onClick={onClickPopupClose}
					>
						<img src="img/popCloseBtn.png" alt="닫기" />
					</button>
				</header>
				<section>
					{data.weighted ? (
						<>
							<div>
								<p>지역활력지수(기존):</p>
								<p>{data.regionVal}</p>
							</div>
							<div>
								<p>지역활력지수(가중치):</p>
								<p>{data.weightedVal}</p>
							</div>
						</>
					) : (
						<div>
							<p>지역활력지수:</p>
							<p>{data.regionVal}</p>
						</div>
					)}
					<div>
						<p>인구활력도:</p>
						<p>{data.popVal}</p>
					</div>
					<div>
						<p>소비활력도:</p>
						<p>{data.consumeVal}</p>
					</div>
					<div>
						<p>생산활력도:</p>
						<p>{data.prodVal}</p>
					</div>
				</section>
			</div>
		</div>
	);
}

export default Popup;
